import module from 'fanconsultores/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('dashboard.contabilidad', {
    data: {title: 'Contabilidad'},
    url: '/contabilidad',
    template: '<fanconsultores-admin-dashboard-contabilidad></fanconsultores-admin-dashboard-contabilidad>',
  })
})



// WEBPACK FOOTER //
// ./src/fanconsultores/routes/dashboard/contabilidad.js